import React from 'react';
import * as R from 'ramda';
// helpers/constants
import * as GC from '../../../constants';
// ui
import { Box, Flex } from '../../../ui';
//////////////////////////////////////////////////

const themeConfigMap = {
  blackorange: {
    label: 'Black-Orange',
    bg: 'linear-gradient(to left, #F56B30 50%, #222222 50%)',
  },
  brightorange: {
    bg: '#FB7841',
    label: 'Bright-Orange',
  },
  dark: {
    bg: '#424242',
    label: 'Dark',
  },
  softdefault: {
    bg: '#CDCDCF',
    label: 'Default',
  },
  green: {
    bg: '#69b01e',
    label: 'Green',
  },
  lightblue: {
    bg: '#03A9F4',
    label: 'Light Blue',
  },
  macos: {
    bg: '#AAAEB5',
    label: 'macOS',
  },
  midnight: {
    bg: '#111111',
    label: 'Midnight',
  },
  orange: {
    bg: '#FFCCBC',
    label: 'Orange',
  },
  pink: {
    bg: '#FFECF1',
    label: 'Pink',
  },
  purple: {
    bg: '#7E57C2',
    label: 'Purple',
  },
  stripedblue: {
    label: 'Striped-Blue',
    bg: 'repeating-linear-gradient(to bottom, #0277BD, #0277BD 50%, #0090DE 50%, #0090DE)',
  },
  stripedteal: {
    label: 'Striped-Teal',
    bg: 'repeating-linear-gradient(to bottom, #007A6E, #007A6E 50%, #009688 50%, #009688)',
  },
  teal: {
    bg: '#009688',
    label: 'Teal',
  },
  yellow: {
    bg: '#FBC02D',
    label: 'Yellow',
  },
};

const defaultThemes = R.keys(themeConfigMap);

const Label = ({ theme }) => (
  <Flex>
    <Box width={15} height={15} borderRadius='50%' background={R.path([theme, 'bg'], themeConfigMap)} />
    <Box ml={5}>{R.pathOr('Theme', [theme, GC.FIELD_LABEL], themeConfigMap)}</Box>
  </Flex>
);

const themeOptions = R.map(
  (theme) => ({
    [GC.FIELD_VALUE]: theme,
    [GC.FIELD_LABEL]: <Label theme={theme} />,
  }),
  defaultThemes,
);

export {
  themeOptions,
  defaultThemes,
};
